import Vue              from 'vue'
import App              from './App.vue'
import router           from './router'
import store            from './store'
import Mixins           from './mixins'
import BasicMixins      from './basic_mixins'
import excel            from 'vue-excel-export'
import vuetify          from '@/plugins/vuetify' // path to vuetify export
import axios            from '@/plugins/axios'  // instace of Http cliente Axios 
import VueSignaturePad  from 'vue-signature-pad';
import VueObserveVisibility from 'vue-observe-visibility'

import 'vuetify/dist/vuetify.min.css'
import { ValidationProvider, extend , ValidationObserver} from 'vee-validate';

import * as rules   from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';


Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Vue.config.productionTip = false
Vue.use(excel)
Vue.use(VueSignaturePad)
Vue.use(VueObserveVisibility)


// window.Echo = initializeEcho(process.env.VUE_APP_ENVIRONMENT)


Vue.mixin({
  mixins: [
    BasicMixins,
    Mixins,
  ],
  methods: {
    ... axios,
    // customFormatter(date) {
    //   return moment(date).format('MMMM Do YYYY');
    // }
  },
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
